export const images = {
  info: require('./icons-info/icons-info.svg'),
  call: require('./call-black.svg'),
  sent: require('./images-sent/images-sent.svg'),
  arrow: require('./icons-arrow/icons-arrow.svg'),
  done: require('./done/done.svg'),
  error: require('./error.svg'),
  changeAccount: require('./change-account/change-account.svg'),
};

export const changeAccountImage = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
<g fill="none" fill-rule="evenodd">
    <g>
        <path d="M0 0h32v32H0z"/>
        <circle stroke="#000" stroke-width="2" cx="11" cy="13.5" r="6.5"/>
        <path d="M19.427 7.242A6.5 6.5 0 1 1 21.19 20M2 24.675a11.002 11.002 0 0 1 18-.001M21.19 20a10.987 10.987 0 0 1 9 4.674" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M0 0h32v32H0z"/>
    <path d="M19.427 7.242A6.5 6.5 0 1 1 21.19 20m0 0a10.987 10.987 0 0 1 9 4.674" stroke="var(--theme-primary, #810ea9)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>`;
